module.exports = __webpack_public_path__ + "img/index_mcont_two.946574e9.png";